export const screenWidth = 1320;
export const screenHeight = 780;
export const targetScreenWidth = 1024;
export const targetScreenHeight = 660;
export const containerId = "container";